/**
 * El cierre de período, para verlo sin backend.
 *
 * Los datos reproducen el caso normal —el mes terminó, los dos sistemas
 * contestan— y además dejan un intento anterior fallado, que es la situación
 * que hace falta poder mirar: un cierre que corrió y **no** cerró.
 */
const AHORA = new Date();

/** El mes anterior al corriente, que es el que un cierre normal tiene enfrente */
function mesPasado(atras: number): string {
  const d = new Date(AHORA.getFullYear(), AHORA.getMonth() - atras, 1);

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

const PROCESOS = [
  { clave: 'catalogos', rotulo: 'Catálogos', detalle: 'Unidades de negocio, regiones, tipos de servicio y demás listas.', sistema: 'armus', por_periodo: false },
  { clave: 'monedas', rotulo: 'Monedas y tipos de cambio', detalle: 'Las cotizaciones con las que se convierte todo lo del mes.', sistema: 'armus', por_periodo: false },
  { clave: 'empresas', rotulo: 'Empresas', detalle: 'Las sociedades de ARMUS. Las nuevas entran apagadas.', sistema: 'armus', por_periodo: false },
  { clave: 'estados', rotulo: 'Estados de proyecto', detalle: 'Los estados y las transiciones permitidas entre ellos.', sistema: 'armus', por_periodo: false },
  { clave: 'tarifas', rotulo: 'Tarifas por rol', detalle: 'El valor hora de cada rol.', sistema: 'trakkinn', por_periodo: false },
  { clave: 'empleados', rotulo: 'Empleados', detalle: 'Las personas contra las que se resuelven gerentes y responsables.', sistema: 'armus', por_periodo: false },
  { clave: 'proyectos', rotulo: 'Proyectos', detalle: 'Cabecera, fechas, márgenes, responsables, cliente y estado.', sistema: 'armus', por_periodo: false },
  { clave: 'contactos', rotulo: 'Contactos de cliente', detalle: 'La agenda de cada cliente, con los cambios hechos en ARMUS.', sistema: 'armus', por_periodo: false },
  { clave: 'componentes', rotulo: 'Componentes de costo', detalle: 'Contra qué se imputan las provisiones.', sistema: 'armus', por_periodo: false },
  { clave: 'ventas', rotulo: 'Órdenes de venta', detalle: 'Lo vendido, que es contra lo que se compara lo facturado.', sistema: 'armus', por_periodo: true },
  { clave: 'facturas', rotulo: 'Facturas de venta', detalle: 'Los ingresos del mes, con sus cobros.', sistema: 'armus', por_periodo: true },
  { clave: 'costos', rotulo: 'Facturas de costo', detalle: 'Los costos imputados del mes, con sus líneas.', sistema: 'armus', por_periodo: true }
];

export function respuestaCierre(metodo: string, ruta: string, cuerpo: unknown): unknown | null {
  if (!/\/api\/cierre\/?$/.test(ruta)) {
    return null;
  }

  if (metodo === 'POST') {
    /* En la vista previa el cierre **no cierra**: contesta como el caso que
       más importa mirar, que es el que falló. Un cierre exitoso de mentira
       dejaría la pantalla diciendo que un mes quedó firme cuando no pasó
       nada. */
    const elegidos = (cuerpo as { procesos?: string[] })?.procesos ?? [];

    return {
      success: false,
      message: 'El período NO se cerró: falló Facturas de venta. Revisá el detalle en el '
        + 'monitor y reprocesá.',
      data: {
        periodo: mesPasado(1),
        cerro: false,
        corrida: `EJ-${mesPasado(1)}-2`,
        resultados: PROCESOS
          .filter((p) => elegidos.includes(p.clave))
          .map((p) => p.clave === 'facturas'
            ? { proceso: p.clave, rotulo: p.rotulo, estado: 'error', mensaje: 'ARMUS respondió 500 al pedir /invoice/by-accounts.' }
            : { proceso: p.clave, rotulo: p.rotulo, estado: 'ok', mensaje: 'Sin novedades.' })
      }
    };
  }

  return {
    success: true,
    data: {
      periodo: mesPasado(1),
      siguiente: mesPasado(0),
      motivo_sin_periodo: null,
      sistemas: {
        armus: { en_linea: true, motivo: null, verificado: AHORA.toISOString() },
        trakkinn: { en_linea: true, motivo: null, verificado: AHORA.toISOString() }
      },
      procesos: PROCESOS,
      corridas: [
        {
          code: `EJ-${mesPasado(1)}`,
          estado: 'parcial',
          inicio: new Date(AHORA.getTime() - 3600_000).toISOString(),
          fin: new Date(AHORA.getTime() - 3540_000).toISOString(),
          ok: 11,
          error: 1,
          mensaje: 'El período NO se cerró: falló Facturas de venta.'
        }
      ],
      ultimo_cerrado: {
        periodo: mesPasado(2),
        cerrado_at: new Date(AHORA.getFullYear(), AHORA.getMonth() - 1, 4, 10, 12).toISOString(),
        cerrado_por: 'Silvina Álvarez'
      }
    }
  };
}
